import { DOCUMENT } from '@angular/common';
import { Component, OnInit, Inject } from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { HomepageService } from '../../../services/homepage.service';


@Component({
  selector: 'app-resetmail',
  templateUrl: './resetmail.component.html',
  styleUrls: ['./resetmail.component.css']
})
export class ResetmailComponent implements OnInit {
	updatingEmail:boolean = true;
	error:boolean = false;
	code:string = '';
	emailMessage:string = '';
  constructor(private activatedRoute: ActivatedRoute, @Inject(DOCUMENT) private document: Document,private authService: AuthService, private homepageService: HomepageService, private router: Router) { }

  ngOnInit() {
  	this.document.body.classList.add('inner-page');
  	this.activatedRoute.queryParams.subscribe(params => {
      this.code = params['code'];
    });
    this.updateEmail(this.code);
  }

  //To update mail. This component only to handle BE request coming from link in mail.
  updateEmail(code){
  	var token =  localStorage.getItem('token');
    var locationId = this.homepageService.getLocationId();
    this.authService.updateEmailClick(code, locationId, token).subscribe((data:any) =>{
    	//console.log(data);
    	this.updatingEmail = false;
    	this.emailMessage = data.message;
    	setTimeout(function(){
    		this.router.navigate['home'];
    	},5000);
    },(error)=>{
    	this.error = true; // to show error on FE.
    	this.updatingEmail = false;
    	//console.log(error);
    });
  }

}
